<!--START modal-->
<button id="stockTransferOrder_button_CloseModal" type="button" class="close" data-dismiss="modal" aria-label="Close" tabindex="-1" (click)="closeModal()">
  <span aria-hidden="true">&times;</span>
</button>
<div class="modal-header">
  <h4 class="modal-title me-2">National Inventory Search</h4>
  <div class="input-group w-50 w-md-33">
    <input id="stockTransferOrder_text_SearchFavouriteId" type="text" class="form-control rush-form-control customer-search-textbox" [(ngModel)]="filterKey"
      (keyup)="filter()" placeholder="Search...">
      <span class="input-group-text">
        <i class="fas fa-search" aria-hidden="true"></i>
      </span>
    </div>
  </div>

  <!-- <h5 id="stockTransferOrder_h5_LoadingNationalInventory" class="row modal-body" *ngIf="!filteredCartItems">Loading national inventory...</h5> -->
  <div
    id="stockTransferOrder_div_FilteredCartItemsSection"
    class="modal-body">
    @let inventoryItems = inventoryItems$ | async;
    <div id="stockTransferOrder_div_FilteredCartItems" *ngLet="{currencyCode: currencyCode$ | async} as vm">

      <div id="divProcurement" class="gy-2">
        @if ((filteredCartItems$ | async)?.length) {
          <form id="stockTransferOrder_form_StockTransferOrderForm" #StockTransferOrderForm="ngForm">
            <div ngbAccordion #acc="ngbAccordion" class="accordion-sm gy-1" [closeOthers]="true">
              @for (cartItem of (filteredCartItems$ | async); track cartItem; let i = $index) {
                <div ngbAccordionItem="stockTransferOrder_panel_StockOrderTransfer_{{i}}" #accItem="ngbAccordionItem">
                  <div ngbAccordionHeader class="bg-header">
                    <button ngbAccordionToggle type="button" class="btn accordion-toggle">
                      <div class="d-flex">
                        <div class="px-2">
                          <div>
                            <i id="stockTransferOrder_i_CartItem_{{i}}" class='fa' [ngClass]="accItem.collapsed ? 'fa-plus' : 'fa-minus'" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div class="flex-grow-1 px-3 d-flex gx-3 text-start">
                          <div>
                            <div>
                              <b>Part Number:</b>
                            </div>
                            <div>{{cartItem.partNumber}}</div>
                          </div>
                          <div>
                            <div>
                              <b>Unit Price:</b>
                            </div>
                            @if (cartItem.isSpecialPricing) {
                              <div id="stockTransferOrder_div_IsSpecialPricing" class="text-danger">Special Sale Price</div>
                            }
                            <div [ngClass]="{ 'text-danger': cartItem.isSpecialPricing }">
                              @if (cartItem.isAdjustedPrice) {
                                <span id="stockTransferOrder_span_IsAdjustedPrice"  style="width: 70px;">
                                  {{cartItem.finalPrice==null?"0":cartItem.finalPrice| currency: vm.currencyCode :'symbol':'1.2-2'}}<br />
                                  <span>orig. {{cartItem.listPrice==null?"0":cartItem.listPrice |
                                  currency: vm.currencyCode :'symbol':'1.2-2'}}</span>
                                  @if (cartItem.corePrice>0) {
                                    <span id="stockTransferOrder_span_IsCorePrice"  [ngClass]="{'form-control-removed': cartItem.coreOption == 'CORE1'}"
                                      style="width: 70px;">{{cartItem.corePrice==null?"0":cartItem.corePrice |
                                    currency: vm.currencyCode :'symbol':'1.2-2'}}</span>
                                  }
                                </span>
                              }
                              @if (!cartItem.isAdjustedPrice) {
                                <span
                                  id="stockTransferOrder_span_IsNotAdjustedPrice"
                                  style="width: 70px;">
                                  {{ cartItem.finalPrice == null ? "0" : cartItem.finalPrice | currency: vm.currencyCode :'symbol':'1.2-2' }}
                                  @if (cartItem.corePrice > 0) {
                                    <span
                                      [ngClass]="{'form-control-removed': cartItem.coreOption == 'CORE1'}"
                                      style="width: 70px;">
                                    {{cartItem.corePrice == null ? "0" :cartItem.corePrice | currency: vm.currencyCode :'symbol':'1.2-2'}}</span>
                                  }
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="ms-auto">
                          <button id="stockTransferOrder_button_RemoveCartItem" style="background: transparent; border: none !important;" role="button" (click)="removeCartItem(cartItem)">
                            <i class="fas fa-times text-danger" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <div class="row align-items-center">
                          @if (!cartItem.inventory || !cartItem.inventory?.length) {
                            <div id="stockTransferOrder_div_NoInventory">
                              <h5>None available at any other branches.</h5>
                            </div>
                          }
                          @if (cartItem.inventory && cartItem.inventory?.length > 0) {
                            <div id="stockTransferOrder_div_Inventory" class="inventory-search-table">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>
                                      <a id="stockTransferOrder_a_Branch" role="button" class="hyperlink" href="javascript:void(0)" (click)="sortDataBy(cartItem,'branchCode');">
                                        Branch
                                        <span [hidden]="cartItem.sortBy != 'branchCode'" class="fas" [ngClass]="{'fa-caret-up': cartItem.sortBy == 'branchCode' && cartItem.sortAsc, 'fa-caret-down': cartItem.sortBy == 'branchCode' && !cartItem.sortAsc}">
                                        </span>
                                      </a>
                                    </th>
                                    <th>
                                      <a id="stockTransferOrder_a_Distance" role="button" class="hyperlink" href="javascript:void(0)" (click)="sortDataBy(cartItem,'milesFromSource');">
                                        Distance
                                        <span [hidden]="cartItem.sortBy != 'milesFromSource'" class="fas" [ngClass]="{'fa-caret-up': cartItem.sortBy == 'milesFromSource' && cartItem.sortAsc, 'fa-caret-down': cartItem.sortBy == 'milesFromSource' && ! cartItem.sortAsc}">
                                        </span>
                                      </a>
                                    </th>
                                    <th>
                                      <a id="stockTransferOrder_a_Inventory" role="button" class="hyperlink" href="javascript:void(0)" (click)="sortDataBy(cartItem,'quantity');">
                                        Inventory
                                        <span [hidden]=" cartItem.sortBy != 'quantity'" class="fas" [ngClass]="{'fa-caret-up':  cartItem.sortBy == 'quantity' &&  cartItem.sortAsc, 'fa-caret-down':  cartItem.sortBy == 'quantity' && ! cartItem.sortAsc}">
                                        </span>
                                      </a>
                                    </th>
                                    @if (authorizationService.hasPermission(permission.AllowProcurementOptions)) {
                                      <th id="stockTransferOrder_th_Quantity">
                                        Quantity
                                      </th>
                                    }
                                    @if (authorizationService.hasPermission(permission.AllowProcurementOptions)) {
                                      <th id="stockTransferOrder_th_BlankSpace">
                                        &nbsp;
                                      </th>
                                    }
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (inventory of cartItem.filteredInventories; track inventory; let j = $index) {
                                    <tr id="stockTransferOrder_tr_FilteredInventoryList_{{i}}_{{j}}">
                                      <!--| inventoryFilterPipe:inventoryFilter;-->
                                      <td style="width:30%"><b id="stockTransferOrder_b_branchname_{{i}}_{{j}}">{{inventory.branchCode +" - "+ inventory.branchName}}</b></td>
                                      <td style="width:20%"> {{inventory.milesFromSource}} Miles</td>
                                      <td style="width:20%">{{inventory.quantity}}</td>
                                      @if (authorizationService.hasPermission(permission.AllowProcurementOptions)) {
                                        <td id="stockTransferOrder_td_AllowProcureOptions_{{i}}_{{j}}" style="width:20%; padding-right: 0px; padding-left: 0px;">
                                          <div class="input-group spinner">
                                            <div class="range-text-box" style="width: 100% !important;">
                                              <part-quantity
                                                inputName="stockTransferOrder_text_PartsBuyoutQuantity_{{i}}_{{j}}"
                                                placeholder="Quantity"
                                                [value]="inventory.partsQuantity"
                                                [max]="inventory.quantity"
                                                (onChangeQuantity)="changeQuantity($event, inventory);"
                                                idModifier="stockTransferOrder_text_PartsBuyoutQuantity_{{i}}"
                                                [index]="j"
                                                inputAutoComplete="off"
                                              ></part-quantity>
                                            </div>
                                          </div>
                                        </td>
                                      }
                                      @if (authorizationService.hasPermission(permission.AllowProcurementOptions)) {
                                        <td style="width:10%">
                                          <button
                                            id="stockTransferOrder_button_SubmitAddToCart_{{i}}_{{j}}"
                                            type="submit"
                                            class="btn btn-default yellow-btn"
                                            (click)="addToCart(inventory, cartItem)">
                                            Add&nbsp;to&nbsp;{{openingFrom === 'BCT' ? 'Request' : 'Cart'}}
                                          </button>
                                        </td>
                                      }
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          }
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            </div>
          </form>
        } @else {
          There is nothing else to procure.
        }
      </div>
    </div>
  </div>

  <!--END modal-->
